module.exports = __webpack_public_path__ + "20ca826b4c2be1aa.css";